<template>
  <div class="memo-board">
    <div class="memo">
      <div class="header">
        <EditIcon class="edit" />
        <h4>{{ formatDate(memo.date, 'M/D (dd)') }}のメモ</h4>
      </div>
      <div class="content">
        <p ref="textArea">
          <span ref="contents">{{ memo.contents }}</span>
        </p>
        <Button flat v-if="isMemoOverflow" @click="showEditor">さらに表示</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatDate } from '@/utils/date'
import { debounce } from 'lodash'
import EditIcon from '@/components/icons/edit'
import Button from '@/components/atoms/Button'

export default {
  name: 'MemoBoard',
  components: {
    EditIcon,
    Button,
  },
  data() {
    return {
      isMemoOverflow: false,
    }
  },
  computed: {
    ...mapState(['memo']),
    ...mapGetters({
      getMemo: 'memo/getMemo',
    }),
  },
  watch: {
    getMemo() {
      this.$nextTick(() => {
        this.checkMemoOverflow()
      })
    },
  },
  mounted() {
    this.checkMemoOverflow()
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    formatDate,
    onResize: debounce(function onResize() {
      // eslint-disable-next-line no-invalid-this
      this.checkMemoOverflow()
    }, 200),
    checkMemoOverflow() {
      this.isMemoOverflow = this.$refs.contents.offsetHeight > this.$refs.textArea.offsetHeight
    },
    showEditor() {
      this.$store.commit('memo/show', true)
    },
  },
}
</script>

<style lang="postcss" scoped>
.memo-board {
  color: var(--very-dark-gray);
  font-size: 14px;
  padding: 16px;
}

.memo {
  background-color: var(--white);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  max-height: 120px;
  padding: 8px;
}

.header {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  padding-bottom: 4px;

  .edit {
    fill: var(--very-dark-gray);
    margin-right: 8px;
    width: 20px;
  }
}

.content {
  flex: 1;

  p {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  button {
    float: right;
    font-weight: normal;
    margin-top: 4px;
    padding: 0;
  }
}
</style>
